// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__2oS9p","row":"style_row__2su0O","label":"style_label__3Pqch","value":"style_value__2FD8i"};